jQuery(function($)
{
    var
        { show } = orion,
        { hide } = orion,
        overlayClass = 'overlay',
        fixBackground = 'no-scroll',
        $targetsClick = $(),
        $targetsHover = $(),
        triggersSelector = '.overlay-trigger',
        $triggers = $(triggersSelector),
        triggersHoverSelector = '.overlay-trigger-hover',
        $triggersHover = $(triggersHoverSelector),
        $body = $('body');

    if (0 === $triggersHover.add($triggers).length)
    {
        return;
    }

    function hoverHideAll($overlays)
    {
        $overlays.hide();
    }

    function hoverShow($overlay)
    {
        $overlay
            .fadeIn('fast')
            .trigger(orion.constants.EventOverlayOpened);
    }

    function hoverHide($overlay)
    {
        $overlay.fadeOut('fast').trigger(orion.constants.EventOverlayClosed);
    }

    function clickShow($overlay, $trigger)
    {
        hoverHideAll($targetsHover);
        show($overlay);
        if ($overlay.is('#product-zoom-full'))
        {		// workaround (siehe overlay.scss) da die sticky-footer umsetzung hier mit dem Overlay kollidiert (main hat einen z-Index, der es nicht ermöglicht, den Zoom üder nden Fokus zu legen)
            $body.addClass(fixBackground + ' product-zoom-full-active');
        }
        else
        {
            $body.addClass(fixBackground + ' focus-active');
        }
        $overlay.trigger(orion.constants.EventOverlayOpened);
        $trigger.trigger(orion.constants.EventOverlayOpened);
    }

    function areOverlaysOpen()
    {
        // visible overlay elements selector: id starting with 'overlay-', class 'overlay' and no class 'hidden'
        let visibleOverlays = document.querySelectorAll('[id^=overlay-].' + overlayClass + ':not(.hidden)');

        return visibleOverlays.length > 0;
    }

    function clickHide($overlay)
    {
        hide($overlay);

        if (!areOverlaysOpen())
        {
            $body.removeClass(fixBackground + ' focus-active product-zoom-full-active');
        }

        $overlay.trigger(orion.constants.EventOverlayClosed);
    }

    function clearSchedule($overlay, storage)
    {
        storage = storage || '';

        var schedule = $overlay.data('overlay-schedule' + storage);

        if (!schedule)
        {
            return;
        }

        clearTimeout(schedule);
        $overlay.data('overlay-schedule' + storage, false);
    }

    function schedule($overlay, f, storage)
    {
        var scheduleTimeout;

        storage = storage || '';

        clearSchedule($overlay, storage);

        scheduleTimeout = setTimeout(function()
        {
            f($overlay);
        }, 300);

        $overlay.data('overlay-schedule' + storage, scheduleTimeout);
    }

    function prepareTargetsHover()
    {
        var
            $trigger = $(this),
            idTarget = $trigger.data('target'),
            $target = $('#' + idTarget);

        $targetsHover = $targetsHover.add($target);
        $target.hide();
        show($target);
    }

    function prepareTargetsClick()
    {
        var
            $trigger = $(this),
            idTarget = $trigger.data('target'),
            $target = $('#' + idTarget);

        $targetsClick = $targetsClick.add($target);
        hide($target);
    }

    function handleClickTrigger(e)
    {
        var
            $trigger = $(this),
            targetId = $trigger.data('target'),
            $target = $('#' + targetId);

        e.preventDefault();
        clickShow($target, $trigger);
    }

    function handleClickClose(e)
    {
        e.preventDefault();
        console.log('overlay.js handleClickClose');

        clickHide($(this).closest('.overlay'));
    }

    function handleButtonClickClose()
    {
        clickHide($(this).closest('.overlay'));
    }

    function handleClickOverlay(e)
    {
        var $clickedElement = $(e.target);

        if ($clickedElement.is('.overlay'))
        {
            $(this).find('.close')
                .trigger('click');
        }
    }

    function handleMouseenter()
    {
        var targetId = $(this).data('target');

        schedule($('#' + targetId), hoverShow);
    }

    function handleHoverviewMouseenter()
    {
        var targetId = $(this).data('target');

        schedule($('#' + targetId), hoverShow, '-hoverview');
    }

    function handleMouseleave()
    {
        var
            targetId = $(this).data('target'),
            $target = $('#' + targetId);

        clearSchedule($target);
        hoverHide($target);
    }

    function handleHoverviewMouseleave()
    {
        var
            targetId = $(this).data('target'),
            $target = $('#' + targetId);

        clearSchedule($target, '-hoverview');
        hoverHide($target);
    }

    // Warning: Legacy Browser IE
    function showLegacyWarning()
    {
        let myCookies = document.cookie;
        if (!(myCookies.includes('warningLegacyBrowser=accepted')))
        {
            $('#trigger-overlay-legacy-browser').trigger('click');
        }
        $('.js-legacy-browser-link').on('click', () =>
        {
            document.cookie = 'warningLegacyBrowser=accepted; path=/';
        });
    }

    $triggersHover.each(prepareTargetsHover);
    $triggers.each(prepareTargetsClick);

    $body
        .on('mouseenter', triggersHoverSelector, handleMouseenter)
        .on(orion.constants.EventHoverviewMouseenter, triggersHoverSelector, handleHoverviewMouseenter)
        .on('mouseleave', triggersHoverSelector, handleMouseleave)
        .on(orion.constants.EventHoverviewMouseleave, triggersHoverSelector, handleHoverviewMouseleave);

    $body.on('click', triggersSelector, handleClickTrigger);
    $body.on('click', '.overlay .close', handleClickClose);
    $body.on('click', '.overlay .close-button', handleButtonClickClose);
    $body.on('click', '.overlay', handleClickOverlay);

    $body.on(orion.constants.EventFocusOverlayClicked, function()
    {
        clickHide($targetsClick);
    });

    // if browser === ie
    if (document.documentMode)
    {
        showLegacyWarning();
    }
});
